import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';


@Component({
    selector: 'app-subida-tomografia',
    templateUrl: './subida-tomografia.component.html',
    styleUrls: ['./subida-tomografia.component.scss'],
    standalone: false
})
export class SubidaTomografiaComponent implements OnInit {
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  selectedFile: File | null = null;
  errorMessage: string | null = null;
  uploadInProgress = false;
  public progress = 0;
  isUploading = false;
  textInput: string = '';
  labelText: string = '';
  public idUsuario!:string;
  private _usuario!: Usuario;
  constructor(private toastr: ToastrService,
    private ordenesService: OrdenesService,
    private authService: AuthService,
  ) { 
    this._usuario = authService.loginUsuario;
  }

  ngOnInit(): void {
    this.idUsuario = this._usuario.idUsuario!;
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      if (file.size > 2000 * 1024 * 1024) { // 2000 gb 
        this.toastr.info('El archivo no debe superar los 2 GB', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }
        this.selectedFile = null;
      } else if (!file.name.endsWith('.zip')) {
        this.toastr.info('El archivo debe tener extensión .zip', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }
        this.selectedFile = null;
      } else {
        this.selectedFile = file;
      }
    }
  }
onUploadFile() {

  if (!this.selectedFile) {
    this.toastr.info('Por favor selecciona un archivo', 'Atención', {
      timeOut: 3000,
      closeButton: true,
      progressBar: true
    });
    return;
  }

  this.textInput = '';
  this.isUploading = true;

  this.ordenesService
    .subirArchivoServidorS3(
      this.selectedFile,
      this.idUsuario,
      localStorage.getItem('token')
    )
    .subscribe(

      (respuesta: any) => {

        if (respuesta?.data?.url) {

          
          this.ordenesService
        .guardarUrlServidor(respuesta.data.key.toString().replace('uploads/', ''), respuesta?.data?.url, this.idUsuario, localStorage.getItem('token'))
        .subscribe((resp:any) => {
           this.isUploading = false;
          this.textInput = resp.urlFile;
            this.toastr.success('Archivo subido con éxito', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
          }

          this.selectedFile = null;
          this.toastr.success('Archivo subido con éxito', 'Atención');

        });
   

         

        } else {

          this.isUploading = false;

          this.toastr.info('Error al subir el archivo', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

        }

      },

      (error) => {

        this.isUploading = false;

        console.error(error);

        this.toastr.error('Error al subir el archivo', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });

        if (this.fileInput) {
          this.fileInput.nativeElement.value = '';
        }

        this.textInput = '';
        this.selectedFile = null;

      }

    );

}
  copyText() {
    const inputElement = document.getElementById('textInput') as HTMLInputElement;
    inputElement.select();
    inputElement.setSelectionRange(0, 99999); // Para dispositivos móviles
    document.execCommand('copy');
    this.labelText = "Texto copiado exitosamente ✅";
  }


}
